import type { ReactNode } from "react";

interface FormWrapperProps {
  children: ReactNode;
}

export const FormWrapper = ({ children }: FormWrapperProps) => (
  <div className="form-wrapper !mt-6">{children}</div>
);
